import { Component, OnInit, ChangeDetectorRef, NgZone, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  template: `
  <div class="modal-header">
    <h5 class="modal-title pull-left">{{header}}</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="decline($event)">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p>{{prompt}}</p>
    <button type="button" class="btn btn-primary" (click)="confirm($event)">Yes</button>
    <button type="button" class="btn btn-danger" (click)="decline($event)">No</button>
  </div>`
})


export class ConfirmModalComponent implements OnInit {
  prompt: string;
  header: string;
  callback: (result: string) => void; // Direct property for callback function
  constructor(
    public bsModalRef: BsModalRef,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private el: ElementRef
  ) { }
  ngOnInit(): void { }
  confirm(event?: MouseEvent) {
    // Stop event propagation
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    try {
      if (this.callback) {
        this.callback('yes');
      }
    } catch (error) {
      console.error('Error in confirm callback:', error);
    }
    // Close modal regardless of callback result
    this.forceCloseModal();
  }
  decline(event?: MouseEvent) {
    // Stop event propagation
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    try {
      if (this.callback) {
        this.callback('no');
      }
    } catch (error) {
      console.error('Error in decline callback:', error);
    }
    // Close modal regardless of callback result
    this.forceCloseModal();
  }
  private forceCloseModal() {
    // Try multiple approaches to ensure the modal closes
    this.ngZone.run(() => {
      try {
        // Simple approach first
        this.bsModalRef.hide();
        // Secondary approach with timeout
        setTimeout(() => {
          try {
            this.bsModalRef.hide();
            this.cdr.detectChanges();
          } catch (error) {
            console.error('Error hiding modal in timeout:', error);
          }
        }, 50);
      } catch (error) {
        console.error('Error in forceCloseModal:', error);
      }
    });
  }
}
